import axios from "@/plugins/axios";

export function getPays(params = {}) {
    return axios.get("pay-merchants", { params });
}

export function addPaysMerchants(data) {
    return axios.post("pay-merchant", data);
}

export function updatePaysMerchants(id, data) {
    return axios.put(`pay-merchant/${id}`, data);
}

export function PaysMerchantsDetails(id) {
    return axios.get(`pay-merchant/${id}`);
}
export function getAreasList() {
    return axios.get("pay-merchants/area-select-options");
}
